import React from 'react';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Anna Schmidt',
      position: 'Gruenderin und Geschaeftsfuehrerin',
      bio: 'Mit ueber 15 Jahren Erfahrung in der Fahrradbranche hat Anna ihre Leidenschaft zum Beruf gemacht. Sie fuehrt unser Team mit Vision und Engagement fuer nachhaltige Mobilitaet.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Sarah Mueller',
      position: 'Leiterin Kundenservice',
      bio: 'Sarah sorgt dafuer dass jeder Kunde ein unvergessliches Erlebnis hat. Ihre Freundlichkeit und Professionalitaet schaetzen unsere Kunden besonders.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Michael Weber',
      position: 'Technischer Leiter',
      bio: 'Als erfahrener Fahrradmechaniker garantiert Michael dass alle unsere Fahrraeder in perfektem Zustand sind. Seine Expertise ist unbezahlbar.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Julia Fischer',
      position: 'Marketing und Content',
      bio: 'Julia ist verantwortlich fuer unsere Online-Praesenz und teilt regelmaessig spannende Geschichten und Tipps rund ums Radfahren in unserem Blog.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Thomas Becker',
      position: 'Tourenexperte',
      bio: 'Thomas kennt jeden Radweg in der Region. Er plant individuelle Routen und begleitet unsere Kunden auf gefuehrten Touren durch die schoensten Landschaften.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta name="description" content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung." />
      </Helmet>

      <div className="about-container">
      <div className="about-header">
        <h1>Ueber uns</h1>
        <p>
          Lernen Sie das Team kennen das Ihre Fahrradtouren unvergesslich macht.
          Wir sind mehr als nur ein Verleih - wir sind Ihre Partner fuer urbane Mobilitaet.
        </p>
      </div>

      <section className="about-blog-section">
        <h2>Unsere Geschichte</h2>
        <p>
          Seit 2017 sind wir Ihr vertrauensvoller Partner fuer Fahrradverleih und urbane Mobilitaet
          in Deutschland. Was als kleine Initiative von Fahrradbegeisterten begann hat sich zu
          einem fuehrenden Service in der Region entwickelt. Unser Ziel war es von Anfang an
          Menschen den Zugang zu qualitativ hochwertigen Fahrraeder zu ermoeglichen und die
          Freude am Radfahren zu teilen.
        </p>
        <p>
          In den letzten Jahren haben wir unsere Flotte kontinuierlich erweitert und modernisiert.
          Heute bieten wir ueber 500 Fahrraeder verschiedener Kategorien an - von klassischen
          Stadtraeder ueber sportliche Trekkingbikes bis hin zu modernen E-Bikes. Jedes Fahrrad
          wird regelmaessig gewartet und gepflegt um Ihnen ein sicheres und komfortables
          Fahrerlebnis zu garantieren.
        </p>
        <p>
          Unser Engagement geht ueber den reinen Verleih hinaus. Wir verstehen uns als Botschafter
          fuer nachhaltige Mobilitaet und setzen uns aktiv fuer den Ausbau der Radinfrastruktur
          ein. Durch Partnerschaften mit lokalen Organisationen und unsere Bildungsarbeit tragen
          wir dazu bei dass immer mehr Menschen das Fahrrad als praktisches und umweltfreundliches
          Verkehrsmittel entdecken.
        </p>
      </section>

      <section>
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', color: 'var(--neon-lime)', marginBottom: '3rem', textShadow: '0 0 15px var(--neon-lime-glow)' }}>
          Unser Team
        </h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <img 
                src={member.image} 
                alt={`Team member ${member.id}`}
                width="400"
                height="400"
                className="team-photo"
              />
              <h3>{member.name}</h3>
              <p className="position">{member.position}</p>
              <p className="bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="about-blog-section" style={{ marginTop: '4rem' }}>
        <h2>Unsere Werte</h2>
        <ul>
          <li>Qualitaet - Wir bieten nur Fahrraeder an die unseren hohen Standards entsprechen</li>
          <li>Nachhaltigkeit - Wir foerdern umweltfreundliche Mobilitaet und reduzieren CO2-Emissionen</li>
          <li>Kundenservice - Ihre Zufriedenheit steht im Mittelpunkt unseres Handelns</li>
          <li>Innovation - Wir bleiben am Puls der Zeit und integrieren neue Technologien</li>
          <li>Gemeinschaft - Wir schaffen Verbindungen zwischen Radfahrern und foerdern den Austausch</li>
        </ul>
      </section>
    </div>
  
    </>);
}

export default About;